import { render, staticRenderFns } from "./PricingReject.vue?vue&type=template&id=4d03cd26&"
import script from "./PricingReject.vue?vue&type=script&lang=js&"
export * from "./PricingReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports